import { combineReducers } from '@reduxjs/toolkit';
import app from './app';
import account from './account';
import approvals from './approvals';
import register from './register';
import regions from './regions';
import countries from './countries';
import timezones from './timezones';
import companyDetails from './companyDetails';
import inventory from './inventory';
import serviceAreas from './serviceAreas';
import shippingTypes from './shippingTypes';
import appliances from './appliances';
import appliance from './appliance';
import workOrders from './workOrders';
import workOrder from './workOrder';
import shipments from './shipments';
import duplication from './duplication';
import certifications from './certifications';
import calendar from './calendar';
import theatres from './theatres';
import workOrderReports from './workOrderReports';

export * from './app';
export * from './account';
export * from './approvals';
export * from './register';
export * from './regions';
export * from './countries';
export * from './timezones';
export * from './companyDetails';
export * from './inventory';
export * from './serviceAreas';
export * from './shippingTypes';
export * from './appliances';
export * from './appliance';
export * from './workOrders';
export * from './workOrder';
export * from './shipments';
export * from './duplication';
export * from './certifications';
export * from './calendar';
export * from './theatres';
export * from './workOrderReports';

export default combineReducers({
  app,
  account,
  approvals,
  register,
  regions,
  countries,
  timezones,
  companyDetails,
  inventory,
  serviceAreas,
  shippingTypes,
  appliances,
  appliance,
  workOrders,
  workOrder,
  duplication,
  shipments,
  certifications,
  calendar,
  theatres,
  workOrderReports,
});
